<section class="stockist_banner p-0">
  <div class="banner_slider_wrapper">
    <div class="box">
      <div class="container wrapper">
        <div class="text opacity-1">
          <h1 class="title title_2">Find a Stockist</h1>
          <h2 class="title_3">
            Find a dealer from our list of trusted partners
          </h2>
        </div>
      </div>
      <img
        src="@/assets/images/falken/find-a-stockist/FindAStockist_header-BG.webp"
        class="d-block w-100"
        alt="Falken Banner Image"
      />
    </div>
  </div>
</section>
<section class="stockist_list_section">
  <div class="container">
    <div class="stockist_grid">
      <div v-for="(stockist, index) in stockists" :key="index" class="stockist_card">
        <div class="logo_wrapper">
          <img :src="stockist.image" :alt="stockist.name" class="stockist_logo" />
        </div>
        <div class="button_group">
          <a :href="stockist.storeLink" target="_blank" class="btn_stockist btn_blue">
            Find a Store
          </a>
          <a :href="stockist.buyLink" target="_blank" class="btn_stockist btn_red">
            Buy Now
          </a>
        </div>
      </div>
    </div>
  </div>
</section>